import { render, staticRenderFns } from "./SyncUserModal.vue?vue&type=template&id=6b51fa79"
import script from "./SyncUserModal.vue?vue&type=script&lang=js"
export * from "./SyncUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports